var sb = require('@sb/util')

function onVisibilityChange (cb) {
	var hidden = 'hidden'

	// Standards:
	if (hidden in document) document.addEventListener('visibilitychange', onchange)
	else if ((hidden = 'mozHidden') in document) document.addEventListener('mozvisibilitychange', onchange)
	else if ((hidden = 'webkitHidden') in document) document.addEventListener('webkitvisibilitychange', onchange)
	else if ((hidden = 'msHidden') in document) document.addEventListener('msvisibilitychange', onchange)
	// IE 9 and lower:
	else if ('onfocusin' in document) document.onfocusin = document.onfocusout = onchange
	// All others:
	else window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange

	function onchange (evt) {
		var v = 'visible'
		var h = 'hidden'
		var evtMap = {
			focus: v,
			focusin: v,
			pageshow: v,
			blur: h,
			focusout: h,
			pagehide: h,
		}

		evt = evt || window.event
		if (evt.type in evtMap) cb(evtMap[evt.type])
		else cb(this[hidden] ? 'hidden' : 'visible')
	}

	// set the initial state (but only if browser supports the Page Visibility API)
	if (document[hidden] !== undefined) onchange({ type: document[hidden] ? 'blur' : 'focus' })
}

const DEF_CHAT_BUTTON_BACKGROUND_IMAGE_URL = 'https://file.mysubiz.com/bubble_11.svg'

const DEFVAL = {
	primary_color: '#0265FF',
	secondary_color: '#555555',
	background: 'linear-gradient(280.16deg, #0053d3 22.03%, #0265ff 78.2%)',
	text_color: 'white',
	width: 375,
	height: 705,
	window_mode: 'mini',
	desktop_button: {
		width: 0.3, // 0 would be left empty, causing invalid css (by less) ??
		height: 0.3,
		border_radius: '100%',
		background_mask_url: DEF_CHAT_BUTTON_BACKGROUND_IMAGE_URL,
		margin_x: 0.3,
		margin_y: 0.3,
	},
	mobile_button: {
		width: 0.3,
		height: 0.3,
		border_radius: '100%',
		background_mask_url: DEF_CHAT_BUTTON_BACKGROUND_IMAGE_URL,
		margin_x: 0.3,
		margin_y: 0.3,
	},
}

function replaceCssVariable (css, setting) {
	// tokenize
	var tokens = [css]
	tokens = tokenize(tokens, "'@primary_color'")
	tokens = tokenize(tokens, '@esc-primary-color-esc')
	tokens = tokenize(tokens, "'@secondary_color'")
	tokens = tokenize(tokens, "'@background'")
	tokens = tokenize(tokens, "'@text_color'")
	tokens = tokenize(tokens, "'@width'")
	tokens = tokenize(tokens, "'@height'")
	tokens = tokenize(tokens, "'@desktop_button.width'")
	tokens = tokenize(tokens, "'@desktop_button.height'")
	tokens = tokenize(tokens, "'@desktop_button.background'")
	tokens = tokenize(tokens, "'@desktop_button.border_radius'")
	//tokens = tokenize(tokens, "'@desktop_button.background_image_url'")
	//tokens = tokenize(tokens, "'@desktop_button.background_mask_url'")
	tokens = tokenize(tokens, "'@desktop_button.margin_x'")
	tokens = tokenize(tokens, "'@desktop_button.margin_y'")
	tokens = tokenize(tokens, "'@mobile_button.width'")
	tokens = tokenize(tokens, "'@mobile_button.height'")
	tokens = tokenize(tokens, "'@mobile_button.background'")
	tokens = tokenize(tokens, "'@mobile_button.border_radius'")
	//tokens = tokenize(tokens, "'@mobile_button.background_image_url'")
	//tokens = tokenize(tokens, "'@mobile_button.background_mask_url'")
	tokens = tokenize(tokens, "'@mobile_button.margin_x'")

	tokens = tokenize(tokens, "'@mobile_button.margin_y'")

	var ret = []
	for (var i = 0; i < tokens.length; i++) {
		var item = tokens[i]
		if (typeof item === 'string') {
			ret.push(item)
			continue
		}

		if (item.type === '@esc-primary-color-esc') {
			var val = sb.get(setting, 'primary_color') || sb.get(DEFVAL, 'primary_color')
			ret.push(encodeURIComponent(norm(val)))
			continue
		}

		// remove @''
		var path = item.type.substr(2, item.type.length - 3)
		var val = sb.get(setting, path) || sb.get(DEFVAL, path) || ''
		val = norm(val)
		if (
			[
				'mobile_button.width',
				'mobile_button.height',
				'mobile_button.margin_x',
				'mobile_button.margin_y',
				'desktop_button.width',
				'desktop_button.height',
				'desktop_button.margin_x',
				'desktop_button.margin_y',
				'width',
				'height',
			].includes(path)
		) {
			val += 'px'
		}

		// mode is full
		if (path === 'height' && sb.get(setting, 'window_mode') === 'full') {
			ret.push('100%')
			continue
		}
		ret.push(val)
	}

	return ret.join('')
}

// tokenizy(['hello XX andy XX go'], 'XX')
// => ['hello ', {type: 'XX'},' andy ', {type: 'XX'}, ' go']
function tokenize (arr, token) {
	if (!arr || !arr.length) return []
	var out = []

	for (let i = 0; i < arr.length; i++) {
		var item = arr[i]
		if (typeof item !== 'string') {
			out.push(item)
			continue
		}
		var ts = item.split(token)
		for (let i = 0; i < ts.length; i++) {
			out.push(ts[i])
			out.push({ type: token })
		}
		out.pop()
	}

	return out
}

function norm (val) {
	if (typeof val === 'string' || val instanceof String) val = val.trim().replace(/;+$/, '')
	return val
}

// set default value if not exists
function fixMissingSetting(setting) {
	// account logo
	if (!sb.get(setting, 'account.logo_url')) {
		sb.set(setting, 'account.logo_url', 'https://filev4.subiz.com/fiqpezhkmeyesdscyetk-default_logo.jpg')
	}

	if (sb.get(setting, 'account_setting.desktop_button.background_image_url')) {
		setting.account_setting.desktop_button.background_image_url = sb.replaceFileUrl(
			setting.account_setting.desktop_button.background_image_url,
		)
	}
	if (sb.get(setting, 'account_setting.desktop_button.background_mask_url')) {
		setting.account_setting.desktop_button.background_mask_url = sb.replaceFileUrl(
			setting.account_setting.desktop_button.background_mask_url,
		)
	}

	if (sb.get(setting, 'account_setting.mobile_button.background_image_url')) {
		setting.account_setting.mobile_button.background_image_url = sb.replaceFileUrl(
			setting.account_setting.mobile_button.background_image_url,
		)
	}
	if (sb.get(setting, 'account_setting.mobile_button.background_mask_url')) {
		setting.account_setting.mobile_button.background_mask_url = sb.replaceFileUrl(
			setting.account_setting.mobile_button.background_mask_url,
		)
	}
}

module.exports = {
	onVisibilityChange,
	replaceCssVariable,
	fixMissingSetting,
}
